import React, { useEffect, useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import { Outlet, useLocation } from 'react-router-dom';

const Layout = ({unread, setPanelOpen}) => {
        const location = useLocation();

    const route_Title = {
        '/livefeed': 'Live Feed',
        '/event-news': 'Dashboard',
        '/upcoming-events': 'Upcoming Events',
        '/subscription': 'Subscription',
        '/settings': 'Settings',
        '/help': 'Help',
    };
    const pageTitle = route_Title[location.pathname] || 'Page';
    const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
    const OpenSidebar = () => {
        setOpenSidebarToggle(!openSidebarToggle)
    };
    const [collapsed, setCollapsed] = useState(true);

    useEffect(() => {
        
    }, [pageTitle]);

    return (
        <div className={`grid-container ${collapsed ? 'collapsed' : ''}`}>
            <Header title={pageTitle} OpenSidebar={OpenSidebar} unread={unread} setPanelOpen={setPanelOpen}/>
            <Sidebar className={collapsed ? 'collapsed' : ''} setCollapsed={setCollapsed} collapsed={collapsed} openSidebarToggle={openSidebarToggle} OpenSidebar={OpenSidebar} />
            <main className='main'><Outlet /></main>
        </div>
    )
}

export default Layout;